import styled from 'styled-components';
import { TextStyles } from '../../shared/TextBlock.styles';

export const TextBlockWrapper = styled.div<{
  type: 'xs' | 'sm' | 'md' | 'lg';
}>`
  ${TextStyles}
`;
